/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateEventInNearbyWeekChangeInput = {
    calendarIds: Array<string>;
    orgRelayId: string;
};
export type UpdateEventInNearbyWeekChangesSubscriptionVariables = {
    input: UpdateEventInNearbyWeekChangeInput;
};
export type UpdateEventInNearbyWeekChangesSubscriptionResponse = {
    readonly updateEventInNearbyWeekChanges: {
        readonly calendarId: string;
        readonly currentMillis: number;
        readonly affectedWeeks: ReadonlyArray<string>;
    } | null;
};
export type UpdateEventInNearbyWeekChangesSubscription = {
    readonly response: UpdateEventInNearbyWeekChangesSubscriptionResponse;
    readonly variables: UpdateEventInNearbyWeekChangesSubscriptionVariables;
};



/*
subscription UpdateEventInNearbyWeekChangesSubscription(
  $input: UpdateEventInNearbyWeekChangeInput!
) {
  updateEventInNearbyWeekChanges(input: $input) {
    calendarId
    currentMillis
    affectedWeeks
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "EventInNearbyWeekChange",
            "kind": "LinkedField",
            "name": "updateEventInNearbyWeekChanges",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "calendarId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentMillis",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "affectedWeeks",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UpdateEventInNearbyWeekChangesSubscription",
            "selections": (v1 /*: any*/),
            "type": "Subscription",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UpdateEventInNearbyWeekChangesSubscription",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "bcb73c3873e5a196aa76c6413d82c8a4",
            "id": null,
            "metadata": {},
            "name": "UpdateEventInNearbyWeekChangesSubscription",
            "operationKind": "subscription",
            "text": "subscription UpdateEventInNearbyWeekChangesSubscription(\n  $input: UpdateEventInNearbyWeekChangeInput!\n) {\n  updateEventInNearbyWeekChanges(input: $input) {\n    calendarId\n    currentMillis\n    affectedWeeks\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'e30bc46db6bdf991a04f42c2a6d75db6';
export default node;
